import { render, staticRenderFns } from "./setting-workflowDefaults.vue?vue&type=template&id=129127d6&scoped=true&"
import script from "./setting-workflowDefaults.vue?vue&type=script&lang=js&"
export * from "./setting-workflowDefaults.vue?vue&type=script&lang=js&"
import style0 from "./setting-workflowDefaults.vue?vue&type=style&index=0&id=129127d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129127d6",
  null
  
)

export default component.exports